// extracted by mini-css-extract-plugin
module.exports = {"local--globals":"custom-local-theme_local--globals__3J7lj"};